import {
  Bottom,
  Container,
  Time,
  Desc,
  Image,
  Read,
  Title,
  Top,
} from "./Blog.Elements";
import "./blog.css";
import { Link } from "react-router-dom";

const Blog = ({ blog }) => {
  let modifiedDate = new Date(blog.createdAt).toDateString();
  let formattedDate = `${modifiedDate.substring(
    4,
    10
  )}, ${modifiedDate.substring(10)}`;
  return (
    <Container className='blog'>
      <Top>
        <Image src={blog.thumbnailImage} alt='' />
      </Top>
      <Bottom>
        <Time>{formattedDate}</Time>
        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to={`/blogs/${blog._id}`}
        >
          <Title>
            {blog.title.length > 20
              ? blog.title.substring(0, 20) + "..."
              : blog.title}
          </Title>
        </Link>
        <Desc>{blog.shortDesc.substring(0, 90) + "..."}</Desc>
        <Link
          style={{ textDecoration: "none", color: "inherit" }}
          to={`/blogs/${blog._id}`}
        >
          <Read>Read More</Read>
        </Link>
      </Bottom>
    </Container>
  );
};

export default Blog;
